














































































import { Component, Inject, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Component as LoadingSpinner } from '@/components/spinners';
import { Warning, Info } from '@/pages/profile/components';
import Infotext from '@/components/parts/infotext';
import ViewsProps from '@/pages/profile/modules/remote-edu/mixins/viewsProps';
import { Top } from '../components';
import ExtButton from '@/components/ext/Button.vue';
import { AppText, AppList, AppHeading } from '@/uikit';
import { Checkbox, Radio } from '@/components/form/';
import { PaginationLayout } from '@/components/parts/listlayout';
import { Paginator as PaginatorDefault } from './components/pagination';
import { ExaminationItemObject, Questions, Question } from './types';
import {
  pluralizeMinutes,
  pluralizeHours,
  pluralizeSeconds,
  pluralizeQuestion,
  pluralizeAttempt,
} from '@/tools/pluralize';
import { remoteEduService } from '@/services';
import { AxiosInstance as ApiInstance } from 'axios';
import ResultTestModalBody from '@/pages/profile/modules/remote-edu/resultTestModalBody/ResultTestModalBody.vue';

@Component({
  components: {
    Top,
    LoadingSpinner,
    Infotext,
    Warning,
    Info,
    AppText,
    AppHeading,
    AppList,
    ExtButton,
    Checkbox,
    Radio,
    PaginationLayout,
    PaginatorDefault,
  },
})
export default class ExaminationItem extends Mixins(ViewsProps) {
  @Inject() $api: ApiInstance;

  @Prop({ type: Object, required: true })
  item: ExaminationItemObject;

  isStart = false;
  isFinish = false;
  passedTest = false;
  time_for_question = false;
  page = 1;
  next_attempt = 1;
  numberOfAttempts = 1;
  timer = '';
  hours = '';
  minutes = '';
  seconds = '';
  globalArrayWithQuestions: Array<Questions> = [];
  results: object = {};
  timeinterval: NodeJS.Timeout;
  createResult: any = null;

  get examinationRules() {
    // надписи просто
    const numberOfQuestions = this.item.count_questions;
    const numberOfAttempts = this.item.count_attempt;
    const editAnswers = this.item.edit_answers;
    const testRunTime = this.item.test_runtime;
    const timeForQuestion = this.item.time_for_question;

    const data = [];
    if (numberOfQuestions) {
      const text1 = `Вам нужно выбрать ответы из ${pluralizeQuestion(
        numberOfQuestions
      )}`;
      data.push(text1);
    }
    if (numberOfAttempts) {
      const text2 = `Для этого у вас будет ${pluralizeAttempt(
        numberOfAttempts
      )}`;
      data.push(text2);
    }
    if (editAnswers) {
      const text3 = `Вы сможете редактировать ответы`;
      data.push(text3);
    } else {
      const text3 = `Вы не сможете редактировать ответы`;
      data.push(text3);
    }
    if (timeForQuestion) {
      const text4 = `Для выполнения теста вам дается некоторое количество времени на каждый вопрос`;
      data.push(text4);
    } else if (testRunTime) {
      const text4 = `Для выполнения теста вам дается ${this.parseTestRuntime(
        testRunTime
      )}.`;
      data.push(text4);
    } else {
      const text4 = `Для выполнения теста вам дается неограниченное время`;
      data.push(text4);
    }

    return data;
  }

  get resultFields() {
    const data = [];
    if (this.createResult) {
      const text1 = `Номер попытки ${this.createResult.attempt_number} из ${this.createResult.count_attempt} возможных`;
      data.push(text1);
      const text3 = `Количество набранных баллов ${this.createResult.sum_weight}`;
      data.push(text3);
    } else if (this.item.result_params) {
      const text1 = `Номер попытки ${this.item.result_params.last_attempt} из ${this.item.count_attempt} возможных`;
      data.push(text1);
      const text3 = `Количество набранных баллов ${this.item.result_params.sum_weight}`;
      data.push(text3);
    }
    return data;
  }

  get pagesCount() {
    if (this.globalArrayWithQuestions.length) {
      return this.globalArrayWithQuestions.length;
    }
    return 1;
  }

  get questions() {
    let data: Array<Question> = [];
    if (this.globalArrayWithQuestions.length) {
      data = this.globalArrayWithQuestions[this.page - 1];
    }
    return data;
  }

  @Watch('item', { immediate: true })
  onChangeItem(item: any): void {
    if (!item.id) return;
    this.convertData();
  }

  @Watch('page')
  onChangePage(page: number): void {
    if (this.time_for_question && this.seconds !== '00') {
      clearInterval(this.timeinterval);
      const timer = this.questions[0].runtime;
      this.startTimer(timer);
    }
  }

  destroyed() {
    clearInterval(this.timeinterval);
  }

  startTest() {
    this.isStart = true;
    if (this.timer && !this.time_for_question) {
      this.startTimer(this.timer);
    } else if (this.time_for_question) {
      const timer = this.questions[0].runtime;
      this.startTimer(timer);
    }
  }

  isItemDisabled(variant: any, item: any) {
    const data: any = this.item;
    if (data.edit_answers) {
      return false;
    } else {
      if (item.type === 1) {
        if (item.result) {
          return true;
        } else {
          return false;
        }
      } else if (item.type === 2) {
        if (variant.result) {
          return true;
        }
      }
    }
  }

  isReatyToFinish() {
    const data: any = this.item;
    let questions = data.questions;
    let count = 0;
    if (this.time_for_question) {
      questions = this.questions;
    }
    let finalCount = questions.length;
    for (const item of questions) {
      if (item.type === 1) {
        if (item.result) {
          count++;
        }
      } else if (item.type === 2) {
        const variants = item.variants;
        for (const variant of variants) {
          if (variant.result) {
            count++;
            break;
          }
        }
      }
    }
    if (finalCount === count) {
      return false;
    }
    return true;
  }

  async finishTest() {
    const data: any = this.item;
    const group_id = data.group_id;
    const test_task_id = data.id;
    const attempt_number = this.next_attempt;

    const questions = data.questions;
    const answer_options = questions.reduce((acc, question) => {
      if (question.type === 1) {
        let answer_option_ids = [];
        if (question.result !== undefined) {
          answer_option_ids = [question.result];
        }
        const question_id = question.id;
        const payload = {
          answer_option_ids,
          question_id,
        };
        if (!acc.find((_el) => _el.question_id === question_id)) {
          acc.push(payload);
        }
        return acc;
      } else if (question.type === 2) {
        const question_id = question.id;
        const answer_option_ids = [];
        const variants = question.variants;
        for (const variant of variants) {
          if (variant.result) {
            answer_option_ids.push(variant.id);
          }
        }
        const payload = {
          answer_option_ids,
          question_id,
        };
        if (!acc.find((_el) => _el.question_id === question_id)) {
          acc.push(payload);
        }
        return acc;
      }
    }, []);
    const payloadToPush = {
      group_id,
      test_task_id,
      attempt_number,
      answer_options,
      schedule_id: data.schedule_id,
    };
    const result = await this.result(payloadToPush);
    console.log('result', result);
    this.$ui.$modal.show(
      'ResultTestModalBody',
      {
        settings: {
          size: {
            width: '500px',
            maxWidth: '500px',
          },
          closable: false,
          title: 'Результат выполнения теста',
        },
        bind: this,
        slots: {
          body: {
            component: ResultTestModalBody,
            propsData: {
              result,
            },
          },
        },
      },
      {
        close: () => {
          this.backToTests();
        },
      }
    );
    this.convertData();
    clearInterval(this.timeinterval);
  }

  async result(val: any) {
    const { $api } = this;
    this.$emit('setStatus', 'loading');
    try {
      const { data } = await remoteEduService(
        $api
      ).postRemoteEduExaminationItem({ data: val });
      this.createResult = data;
      this.$emit('setStatus', 'success');
      return data;
    } catch (err) {
      this.$emit('setStatus', 'error');
      return err.response.data;
    }
  }

  shuffle(arr: object[]) {
    const array = arr;
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  resetTest() {
    this.page = 1;
  }

  backToTests() {
    this.$router.push({ path: '/profile/examination' });
  }

  convertData() {
    const data: any = this.item;
    const result: any = [[]];
    const fakePages = data.new_page;
    const actualPage = fakePages - 1;
    let questions = data.questions;
    const randomOrder = data.random_order;
    this.numberOfAttempts = Number(data.count_attempt);
    this.next_attempt = data.result_params.next_attempt;
    this.passedTest = data.result_params.passed;
    this.timer = data.test_runtime;
    this.time_for_question = data.time_for_question;
    let count = 1;
    let pageToPush = 0;
    if (randomOrder) {
      questions = this.shuffle(questions);
    }
    if (fakePages === '1') {
      result[pageToPush] = questions;
    }
    for (let i = 0; i < questions.length; i++) {
      const item = questions[i];
      item.questionCount = i + 1;
      if (count < actualPage) {
        result[pageToPush].push(item);
        count++;
      } else if (count === actualPage) {
        result[pageToPush].push(item);
        count = 1;
        pageToPush++;
        if (i !== questions.length - 1) {
          result[pageToPush] = [];
        }
      }
    }
    this.globalArrayWithQuestions = result;
    if (this.passedTest) {
      this.stopTest(true);
    }
  }

  parseTestRuntime(testRunTime: string) {
    const timerArray = testRunTime.split(':');
    const newDateHours = timerArray[0];
    let newDateHoursString = '';
    const newDateMinutes = timerArray[1];
    let newDateMinutesString = '';
    const newDateSeconds = timerArray[2];
    let newDateSecondsString = '';
    if (newDateHours !== '00') {
      newDateHoursString = `${pluralizeHours(newDateHours)}`;
    }
    if (newDateMinutes !== '00') {
      newDateMinutesString = `${pluralizeMinutes(newDateMinutes)}`;
    }
    if (newDateSeconds !== '00') {
      newDateSecondsString = ` ${pluralizeSeconds(newDateSeconds)}`;
    }
    return `${newDateHoursString}${newDateMinutesString}${newDateSecondsString}`;
  }

  startTimer(timer: string) {
    const date = new Date();
    const deadlineDate = new Date();
    const timerArray = timer.split(':');
    const newDateHours = Number(timerArray[0]);
    const newDateMinutes = Number(timerArray[1]);
    const newDateSeconds = Number(timerArray[2]);
    const oldDateHours = date.getHours();
    const oldDateMinutes = date.getMinutes();
    const oldDateSeconds = date.getSeconds();
    deadlineDate.setHours(oldDateHours + newDateHours);
    deadlineDate.setMinutes(oldDateMinutes + newDateMinutes);
    deadlineDate.setSeconds(oldDateSeconds + newDateSeconds);
    this.initializeClock(deadlineDate);
  }

  getTimeRemaining(endtime: Date) {
    var t = Date.parse(endtime.toString()) - Date.parse(new Date().toString());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      total: t,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  }

  initializeClock(endtime: Date) {
    const vm = this;
    const getTimeRemaining = this.getTimeRemaining;

    function updateClock() {
      var t = getTimeRemaining(endtime);
      vm.hours = ('0' + t.hours).slice(-2);
      vm.minutes = ('0' + t.minutes).slice(-2);
      vm.seconds = ('0' + t.seconds).slice(-2);

      if (t.total <= 0) {
        clearInterval(vm.timeinterval);
        if (vm.time_for_question) {
          vm.nextQuestion();
        } else {
          vm.finishTest();
        }
      }
    }

    updateClock();
    this.timeinterval = setInterval(updateClock, 1000);
  }

  nextQuestion() {
    if (this.page === this.globalArrayWithQuestions.length) {
      this.finishTest();
      return;
    }
    this.page += 1;
    const timer = this.questions[0].runtime;
    this.startTimer(timer);
  }

  stopTest(loading: boolean) {
    this.isStart = false;
    this.isFinish = true;
    if (loading) {
      this.loadingResults();
    }
  }

  runTestAgain() {
    this.isStart = false;
    this.isFinish = false;
  }

  async loadingResults() {
    this.$emit('getResult', this.createResult);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/examination-item/examinationItem.vue